import View from "./View";

export default function Container({self = false, ranking, ci, record, name}) {
  return <View self={self} ranking={ranking} record={record} name={name} />;
}
